import { Component } from 'react';
import { ReactComponent as Delete } from 'assets/images/svg/delete.svg';
import DeleteButton from 'Components/Table/DeleteButton';
import DataTable from 'Container/DataTable/DataTableContainer';
import Pagination from 'Components/Pagination';
import Popup from 'Components/Common/PopUp';
import { ModuleActions } from 'Constants/Modules.constants';
import { tableConstants } from 'Constants';
// import { tableConstants } fro,

class UsersGrid extends Component {
    constructor(props){
        super(props);

        const headers = [
            {
                className: tableConstants.DEFAULT_WIDTH,
                title: 'Mobile Number',
                chooseOption: {
                  name: 'mobileNumber',
                  Component: 'Search',
                  dispatchFunction: this.handleSearch
                },
                accessor: 'mobileNumber',
                sortOption: true,
            },
            {
                className:tableConstants.NAME_WIDTH,
                title: 'Name',
                chooseOption: {
                    name: 'name',
                    Component: 'Search',
                    dispatchFunction: this.handleSearch
                },
                accessor: 'name',
                sortOption: true,
                isDataEncrypted: true,
                tooltip: true
            },
            {
                className:tableConstants.DATE_RANGE_WIDTH,
                title: 'Access Granted Date',
                chooseOption: {
                  name: 'accessGrantedDate',
                  Component: 'DatePickerComponent',
                  dispatchFunction: this.handleDateSearch,
                  dateFormat: 'yyyy-MM-dd',
                  maxDate: new Date()
                },
                accessor: 'accessGrantedDate',
                sortOption: true,
            },
            {
                className:tableConstants.NAME_WIDTH,
                title: 'Access Granted By',
                chooseOption: {
                  name: 'accessGrantedBy',
                  Component: 'Search',
                  dispatchFunction: this.handleSearch
                },
                accessor: 'accessGrantedBy',
                sortOption: true,
                tooltip: true
            },
            {
                className:tableConstants.DATE_RANGE_WIDTH,
                title: 'Registered On Date',
                chooseOption: {
                    name: 'registeredOn',
                    Component: 'DropDown',
                    DropdownText:'All',
                    dispatchFunction: this.handleSearch,
                    optionRender: () => {
                        const types = [
                            { id:1, name:'Registered' },
                            { id:0, name:'Not Registered' }
                        ]
                        return types.map((type, index) => {
                            return (
                                <option data-rolename={ type.name } key={ `registered_on_date_${ index }` } value={ type.id }>
                                    { type.name }
                                </option>
                            )
                        })
                    }
                },
                accessor: 'registeredOnDate',
                sortOption: true,
                cell: function(rowDetails) {
                    const { registeredOnDate, index, roleName } = rowDetails;
                    return <td key={ index } className='w-30'>{registeredOnDate || '-'}</td>;
                },
            }
        ];

        if(this.props.permission?.[ ModuleActions.delete ]){
            headers.unshift({
                title:'checkbox',
                sortOption: false,
                headerCell: () => {
                    if(this.props.appAccessControlUsers?.responseData?.length === 0){
                        return null;
                    }
                    const isChecked = this.state.allRowSelected || this.state.partialRowsSelected;
                    let className = '';
                    if(this.state.allRowSelected){
                        className = ' active';
                    }
                    else if(this.state.partialRowsSelected){
                        className = ' checkbox-par-select';
                    }
                    
                    return <div className={ `thcus-checkbox cus-checkbox${ className }` } onClick={ () => this.toggleSelectAll() }>
                        <input type="checkbox" defaultChecked={ isChecked }/>
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" fill="none" stroke-width="2px" stroke="white" stroke-linecap="round" viewBox="0 0 21 21">
                                <polyline points="5 10.75 8.5 14.25 16 6"></polyline>
                            </svg>
                        </span>
                    </div>
                },
                cell: rowDetail => {
                    const { index, id, rowIdx, ...rest } = rowDetail;
                    const isChecked = this.state.selectedRows.indexOf(id) > -1;
                    return <td key={ index } data-row={ rowIdx } className={ tableConstants.CHECKBOX_WIDTH } >
                        <div className={ `thcus-checkbox cus-checkbox${ isChecked ? ' active' : '' }` } onClick={ () => this.toggleRow(rowDetail) }>
                            <input type="checkbox" defaultChecked={ isChecked }/>
                            <span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" fill="none" stroke-width="2px" stroke="#262626" stroke-linecap="round" viewBox="0 0 21 21">
                                    <polyline points="5 10.75 8.5 14.25 16 6"></polyline>
                                </svg>
                            </span>
                        </div>
                    </td>
                }
            });

            headers.push({
                title: 'Action',
                accessor: 'id',
                chooseOption:{
                    Component: 'RefreshIcon',
                    dispatchFunction: this.props.refreshGrid
                },
                cell: rowDetail => {
                    const { index, id, rowIdx, profile, ...rest } = rowDetail;
                    return (
                    <td key={ index } data-row={ rowIdx } className='action'>
                        <DeleteButton
                          remainningRecords={ this.props.appAccessControlUsers.totalRecords }
                          activeQuery={ this.props.filteredWithSort }
                          deleteActionListener={ this.props.appAccessControlDeleteUserAction }
                          id={ id }
                          checkPermission={ true }
                          currentPage = { this.props.appAccessControlUsers.currentPage }
                          disable = { false }
                        />
                    </td>
                    );
                }
            });
        }

        this.state={
            headers,
            selectedRows: [],
            allRowSelected: false,
            partialRowsSelected: false,
            bulkRowDeletePopup: false
        }
    }

    /**
     * @method handleSearch
     * @summary set the username and password state
     * @param {event} event - React onChange event
     * @return { function } formUrlParams
    */
    handleSearch = event => {
        const { name, value } = event.target;
        this.props.formUrlParams(name, value);
        this.resetBulkRowDelete();
    };

    /**
     * @method setPageLimit
     * @summary set page limit for view data per page
     * @param {name} name - Query string name
     * @param {value} value - Query string value
     * @return { function } formUrlParams
    */
    setPageLimit = (name, value) => {
        this.props.formUrlParams(name, value, { pageLimit: value });
        this.resetBulkRowDelete();
    };

    handleDateSearch = (name, selectedDate) => {
        this.props.formUrlParams(name, selectedDate);
        this.resetBulkRowDelete();
    };

    componentDidUpdate(prevProps){
        if(prevProps.appAccessControlUsers.responseData !== this.props.appAccessControlUsers.responseData){
            this.setAllRowSelected();
        }

        if(prevProps.refreshGridTime !== this.props.refreshGridTime && this.props.refreshGridTime){
            this.resetBulkRowDelete();
        }

        if(prevProps.appAccessControlDeleteUser !== this.props.appAccessControlDeleteUser && this.props.appAccessControlDeleteUser.userId){
            this.handleDeleteRow(this.props.appAccessControlDeleteUser.userId);
        }
    }

    /**
     * Check If deleted row is part of selected row array.
     * Need to remove the deleted user from selected row array
     * and update the UI.
     * */
    handleDeleteRow = (userId) => {
        const selectedRows = [ ...this.state.selectedRows ];
        const rowIndex = selectedRows.indexOf(userId);
        if(rowIndex > -1){
            selectedRows.splice(rowIndex, 1);
            this.setState({ selectedRows });
            this.setAllRowSelected(selectedRows);
        }
    }

    toggleRow = (rowDetail) => {
        const selectedRows = [ ... this.state.selectedRows ];
        const rowIndex = selectedRows.indexOf(rowDetail.id);
        let allRowSelected = false;
        let partialRowsSelected = false;

        if(rowIndex === -1){
            selectedRows.push(rowDetail.id);
            this.setAllRowSelected(selectedRows);
            this.setState({ selectedRows });
        }
        else{
            selectedRows.splice(rowIndex, 1);
            partialRowsSelected = !!selectedRows.length;
            this.setState({ selectedRows, allRowSelected, partialRowsSelected });
        }
        this.reRenderHeaders();
    }

    toggleSelectAll = () => {
        const selectedRows = [ ...this.state.selectedRows ];
        let recordToBeSelected = [];
        const currentPageData = this.props.appAccessControlUsers.responseData;
        let allRowSelected = false;
        let partialRowsSelected = false;
        if(!this.isPartialRowsSelected(selectedRows)){
            recordToBeSelected = currentPageData.map((user) => user.id);
            allRowSelected = true;
        }
        else {
            currentPageData.map((user) => {
                const rowIndex = selectedRows.indexOf(user.id);
                if(rowIndex > -1){
                    selectedRows.splice(rowIndex, 1);
                }
            });
        }

        this.setState({ selectedRows: [ ...selectedRows, ...recordToBeSelected ], allRowSelected, partialRowsSelected });
        this.reRenderHeaders();
    }

    isPartialRowsSelected = (selectedRows) => {
        selectedRows = selectedRows || this.state.selectedRows;
        const currentPageData = this.props.appAccessControlUsers.responseData;
        return currentPageData.some((user) => selectedRows.indexOf(user.id) > -1);
    }

    isAllRowSelected = (selectedRows) => {
        selectedRows = selectedRows || this.state.selectedRows;
        const currentPageData = this.props.appAccessControlUsers.responseData;
        return Array.isArray(currentPageData) && currentPageData.length > 0 && currentPageData.every((user) => selectedRows.indexOf(user.id) > -1);
    }

    setAllRowSelected = (selectedRows) => {
        const isAllRowSelected = this.isAllRowSelected(selectedRows);
        const isPartialRowsSelected = this.isPartialRowsSelected(selectedRows);
        this.setState({ allRowSelected: isAllRowSelected, partialRowsSelected: isPartialRowsSelected });
        this.reRenderHeaders();
    }

    reRenderHeaders = () => {
        this.setState({ headers: [ ...this.state.headers ] });
    }

    toggleBulkRowDeletePopup = () => {
        this.setState({ bulkRowDeletePopup: !this.state.bulkRowDeletePopup });
    }

    handleBulkRowDelete = () => {
        this.props.appAccessControlDeleteUserAction(
            this.state.selectedRows,
            this.props.filteredWithSort,
            this.props.appAccessControlUsers.totalRecords,
            this.props.appAccessControlUsers.currentPage
        )
        this.toggleBulkRowDeletePopup();
        this.resetBulkRowDelete();
    }

    resetBulkRowDelete = () => {
        if(this.state.selectedRows.length > 0){
            this.setState({ selectedRows: [], allRowSelected: false, partialRowsSelected: false }, () => {
                this.reRenderHeaders();
            });
        }
    }

    render(){
        const { appAccessControlUsers, appAccessControlSwitch, appAccessControlDeleteUser, appAccessControlImportUsers, aacDownloadSampleCsv, aacExportUsers } = this.props;
        return (
            <>
                { this.state.selectedRows.length > 0 && <div className="delete-list">
                    <label>Selected<span>({ this.state.selectedRows.length })</span></label>
                    <label className='delete_btn btn btn_primary_outline' onClick={ () => this.toggleBulkRowDeletePopup() }><i><Delete className='fill-red'/></i>Delete</label>
                </div> }
                <DataTable
                    className='data-table'
                    headers={ this.state.headers }
                    data={ appAccessControlUsers.responseData }
                    noData='No records!'
                    loading={ appAccessControlUsers.loading || appAccessControlSwitch.loading || appAccessControlDeleteUser.loading || appAccessControlImportUsers.loading || aacDownloadSampleCsv.loading || aacExportUsers.loading }
                    sortTable = { this.props.sortTable }
                    refreshGridTime={ this.props.refreshGridTime }
                    activeSort={ this.props.activeSort }
                />
                <Pagination
                    handleClick={ this.props.formUrlParams }
                    totalRecords={ appAccessControlUsers.totalRecords }
                    initialPage={ appAccessControlUsers.currentPage }
                    currentPage={ 1 }
                    setPageLimit={ this.setPageLimit }
                    pageLimit={ this.props.pageLimit }
                />
                { this.state.bulkRowDeletePopup && <Popup popupText={ `Are you sure you want to delete all the selected user${ this.state.selectedRows.length > 1 ? 's' : '' }?` } handleYes={ this.handleBulkRowDelete } handleCancel={ this.toggleBulkRowDeletePopup } /> }
            </>
        )
    }
}

export default UsersGrid;